
import Product from "@/types/Product";
import { useForm } from "@inertiajs/inertia-vue3";
import { computed, defineComponent, PropType, ref, watch } from "vue";
import Modal from "../General/Modal.vue";
import ButtonGroup from "../Buttons/ButtonGroup.vue";
import Button from "../Buttons/Button.vue";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiLoading, mdiPrinter } from "@mdi/js";
import ValidationFormErrors from "../Forms/ValidationFormErrors.vue";

export default defineComponent({
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    product: {
      type: Object as PropType<Product>,
      required: true,
    },
  },
  emits: ["dismiss"],
  setup(props, context) {
    const loading = ref(false);
    const form = useForm({
      small: false,
      priceType: "auto" as "auto" | "normal" | "campaign",
      amount: 1,
      customText: "",
    });

    const customTextVisible = computed(() => {
      if (form.small) {
        return false;
      }

      return true;
    });

    // Make sure amount is 1 when opening
    watch(
      () => props.open,
      (newValue) => {
        if (newValue) {
          form.amount = 1;
        }
      }
    );

    const sizeOptions = [
      {
        value: true,
        label: "Liten",
      },
      {
        value: false,
        label: "Stor",
      },
    ];

    const priceOptions = [
      {
        value: "auto",
        label: "Nåværende pris",
      },
      {
        value: "normal",
        label: "Normalpris",
      },
      {
        value: "campaign",
        label: "Kampanjepris",
      },
    ];

    const amountOptions = [
      {
        value: 1,
        label: "1",
      },
      {
        value: 5,
        label: "5",
      },
      {
        value: 10,
        label: "10",
      },
    ];

    const submit = () => {
      loading.value = true;
      form
        .transform((data) => {
          if (!customTextVisible.value) {
            data.customText = "";
          }

          return data;
        })
        .post(route("products.label.print", { product: props.product.id }), {
          onFinish: () => {
            loading.value = false;
          },
          onSuccess: () => {
            context.emit("dismiss");
          },
          preserveScroll: true,
        });
    };

    return {
      form,
      submit,
      loading,
      sizeOptions,
      priceOptions,
      amountOptions,
      printIcon: mdiPrinter,
      loadingIcon: mdiLoading,
      customTextVisible,
    };
  },
  components: { Modal, ButtonGroup, Button, SvgIcon, ValidationFormErrors },
});
